import connectedStore from 'yola-editor/src/js/store/connected-store';
import selectors from '../selectors';

const getSiteTemplateSlug = () => connectedStore.applySelector(selectors.getSiteTemplateSlug);

export default getSiteTemplateSlug;
